import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`education-module/${id}`)
}
